import { STATUS_PAGE_URL } from 'app/constants';

export const StatusPageLinkModule = angular
    .module('app.components.statusPage.statusPageLink', [])
    .directive('statusPageLink', () => {
        return {
            restrict: 'E',
            template: `
                <a class="md-button status-page-link" ng-href="{{statusPageUrl}}" target="_blank" ng-transclude></a>
            `,
            transclude: true,
            replace: true,
            link: ($scope) => {
                $scope.statusPageUrl = STATUS_PAGE_URL;
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/components/statusPage/statusPageLink.directive.js